import {Close as CloseIcon} from '@mui/icons-material';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Portal} from '@mui/material';
import React from 'react';

const Modal = ({
    id = 'modal-dialog',
    open,
    onClose,
    title,
    description,
    children,
    actions,
    container = document.body,
    is_form = false,
    show_close_button = false,
    onSubmit,
    TitleProps = {},
    ...props
}) => {
    return (
        <Portal container={container}>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby={id + '-title'}
                aria-describedby={description ? id + '-description' : null}
                {...(is_form && {
                    component: 'form',
                    onSubmit: (e) => {
                        if (onSubmit) {
                            onSubmit(e);
                        }
                    },
                })}
                {...props}
            >
                {title && (
                    <DialogTitle id={id + '-title'} {...TitleProps}>
                        {title}
                    </DialogTitle>
                )}
                {show_close_button && (
                    <IconButton aria-label="close" sx={{position: 'absolute', top: 2, right: 2}} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                )}
                <DialogContent
                    className={props?.scroll === 'paper' ? 'visible-scrollbars' : ''}
                    dividers={props?.scroll === 'paper'}
                >
                    {description && <DialogContentText id={id + '-description'}>{description}</DialogContentText>}
                    {children}
                </DialogContent>
                {actions && <DialogActions>{actions}</DialogActions>}
            </Dialog>
        </Portal>
    );
};

export default Modal;
